import React, { useState,useContext } from 'react';
import countries from './utils/countries.json' 
import AuthContext from './Contexts/AuthContext';

function Address(props) {
    const address = props.address
    const showButton = props.showButton

    function getNameCountry(state_code){
        let list_of_country = countries.filter((country)=>{
            return country.code===state_code
        })
        if(list_of_country.length > 0){
            return list_of_country[0].name
        }
        return ""
    }

    return (
        <div className={"col-lg-6 col-md-6 col-sm-12 col-xs-12"}>
            <div className={ showButton ?  "show-button" : null}>
                <div className="row">
                    <div className="bolder-name">{address.name} {address.lastname}</div>
                </div>
                <div className="row">
                    {/* <div className="col-lg-3 col-md-3 col-sm-3 d-none d-sm-block"><b>Città:</b></div> */}
                    <div>{address.city}</div>
                </div>
                <div className="row">
                    {/* <div className="col-lg-3 col-md-3 col-sm-3 d-none d-sm-block"><b>Via:</b></div> */}
                    <div>{address.address}</div>
                </div>
                <div className="row">
                    {/* <div className="col-lg-3 col-md-3 col-sm-3 d-none d-sm-block"><b>Stato</b></div> */}
                    <div>{getNameCountry(address.state)}</div>
                </div> 
                <div className="row">
                    {/* <div className="col-lg-3 col-md-3 col-sm-3 d-none d-sm-block"><b>CAP</b></div> */}
                    <div>{address.zipcode}</div>
                </div>
                {showButton ? 
                    <div className="row" style={{marginTop:"10px"}}>
                    <div className="col-6" style={{cursor:"pointer"}}>
                        <span onClick={()=>props.openModal(address,true)}> <i className="fa fa-refresh"></i>Aggiorna</span> 
                    </div>
                    <div className="col-6" style={{cursor:"pointer"}}>
                        <span onClick={()=>props.deleteAddress(address)}><i className="fa fa-trash-o"></i>Elimina</span>
                    </div> 
                </div>: null}
            </div>
        </div>
    );
}

export default Address;